import { render, staticRenderFns } from "./modalUpdate.vue?vue&type=template&id=2d1d33ac"
import script from "./modalUpdate.vue?vue&type=script&lang=js"
export * from "./modalUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports